
// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const BlogsPage = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [preview, setPreview] = useState(null);
  
// const BASE_URL = "https://server.havbit.in";

//   const fetchBlogs = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/api/blogs`);
//       setBlogs(res.data.blogs || res.data);
//     } catch (err) {
//       console.log("Error fetching blogs:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchBlogs(); }, []);

//   /* Image/Video with fallback */
//   const MediaThumb = ({ blog }) => {
//     const [imgError, setImgError] = useState(false);

//     // ✅ blog.media is already a full Cloudinary URL — use it directly
//     const url = blog.media;

//     if (blog.mediaType === "video") {
//       return (
//         <video
//           src={url}
          
//           preload="metadata"
//           style={{ width: "100%", height: "100%", objectFit: "cover", display: "block",cursor: "pointer" }}
//           onClick={() => setPreview({ url, type: "video" })}
//         />
//       );
//     }

//     if (blog.mediaType === "image" && !imgError) {
//       return (
//         <img
//           src={url}
//           alt={blog.title}
//           style={{ width: "100%", height: "100%", objectFit: "cover", display: "block",cursor: "pointer" }}
//           onError={() => setImgError(true)}
//            onClick={() => setPreview({ url, type: "image" })}
//         />
//       );
//     }

//     /* Fallback placeholder */
//     return (
//       <div style={{
//         width: "100%", height: "100%",
//         display: "flex", flexDirection: "column",
//         alignItems: "center", justifyContent: "center",
//         gap: "8px", color: "#9ca3af", background: "#f3f4f6"
//       }}>
//         <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//           <rect x="3" y="3" width="18" height="18" rx="2"/>
//           <circle cx="8.5" cy="8.5" r="1.5"/>
//           <polyline points="21 15 16 10 5 21"/>
//         </svg>
//         <span style={{ fontSize: "12px" }}>Image not available</span>
//       </div>
//     );
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

//         :root {
//           --bg: #f8f9fc;
//           --surface: #ffffff;
//           --border: #e5e7eb;
//           --text-1: #111827;
//           --text-2: #6b7280;
//           --text-3: #9ca3af;
//           --accent: #2563eb;
//           --radius: 14px;
//           --shadow: 0 1px 3px rgba(0,0,0,.05), 0 4px 16px rgba(0,0,0,.06);
//           --shadow-hover: 0 4px 8px rgba(0,0,0,.08), 0 12px 28px rgba(0,0,0,.1);
//         }

//         .bp * { box-sizing: border-box; margin: 0; padding: 0; }
//         .bp {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           background: var(--bg);
//           min-height: 100vh;
//           padding: 48px 24px 80px;
//           color: var(--text-1);
//         }

//         .bp-header { text-align: center; margin-bottom: 40px; }
//         .bp-header h1 { font-size: 32px; font-weight: 700; letter-spacing: -.5px; margin-bottom: 8px; }
//         .bp-header p { font-size: 15px; color: var(--text-2); }

//         .bp-grid {
//           max-width: 1100px; margin: 0 auto;
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
//           gap: 22px;
//         }

//         .bp-card {
//           background: var(--surface);
//           border-radius: var(--radius);
//           border: 1px solid var(--border);
//           overflow: hidden;
//           box-shadow: var(--shadow);
//           transition: box-shadow .22s, transform .22s;
//         }
//         .bp-card:hover { box-shadow: var(--shadow-hover); transform: translateY(-3px); }

//         .bp-thumb {
//           width: 100%; height: 210px;
//           overflow: hidden; position: relative;
//           background: #f3f4f6;
//         }

//         .bp-thumb img { transition: transform .35s ease; }
//         .bp-card:hover .bp-thumb img { transform: scale(1.05); }

//         .bp-body { padding: 18px 20px 22px; }

//         .bp-tag {
//           display: inline-block;
//           font-size: 10.5px; font-weight: 700;
//           letter-spacing: .07em; text-transform: uppercase;
//           padding: 3px 9px; border-radius: 5px;
//           margin-bottom: 10px;
//         }
//         .bp-tag.image { background: #eff6ff; color: #2563eb; }
//         .bp-tag.video { background: #fdf4ff; color: #9333ea; }

//         .bp-title { font-size: 16px; font-weight: 700; line-height: 1.45; color: var(--text-1); margin-bottom: 8px; }
//         .bp-desc {
//           font-size: 13.5px; color: var(--text-2); line-height: 1.65;
//           display: -webkit-box; -webkit-line-clamp: 3;
//           -webkit-box-orient: vertical; overflow: hidden;
//         }

//         .bp-center {
//           display: flex; flex-direction: column;
//           align-items: center; justify-content: center;
//           min-height: 320px; gap: 14px;
//           color: var(--text-2); font-size: 15px;
//           max-width: 1100px; margin: 0 auto;
//         }
//         .bp-spinner {
//           width: 34px; height: 34px;
//           border: 3px solid var(--border);
//           border-top-color: var(--accent);
//           border-radius: 50%;
//           animation: spin .65s linear infinite;
//         }
//         @keyframes spin { to { transform: rotate(360deg); } }

//         @media (max-width: 640px) {
//           .bp { padding: 32px 16px 60px; }
//           .bp-header h1 { font-size: 24px; }
//           .bp-grid { grid-template-columns: 1fr; }
//         }
//       `}</style>

//       <div className="bp">
//         <div className="bp-header">
//           <h1>Our Blogs</h1>
//           <p>Stories, insights and updates from our team</p>
//         </div>

//         {loading ? (
//           <div className="bp-center">
//             <div className="bp-spinner" />
//             <span>Loading blogs...</span>
//           </div>
//         ) : blogs.length === 0 ? (
//           <div className="bp-center">
//             <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//               <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
//               <polyline points="14 2 14 8 20 8"/>
//               <line x1="16" y1="13" x2="8" y2="13"/>
//               <line x1="16" y1="17" x2="8" y2="17"/>
//             </svg>
//             <span>No blogs found</span>
//           </div>
//         ) : (
//           <div className="bp-grid">
//             {blogs.map((blog) => (
//               <div key={blog._id} className="bp-card">
//                 <div className="bp-thumb">
//                   <MediaThumb blog={blog} />
//                 </div>
//                 <div className="bp-body">
//                   <span className={`bp-tag ${blog.mediaType}`}>
//                     {blog.mediaType === "video" ? "🎬 Video" : "🖼 Image"}
//                   </span>
//                   <div className="bp-title">{blog.title}</div>
//                   <p className="bp-desc">{blog.description}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//       {preview && (
//   <div
//     onClick={() => setPreview(null)}
//     style={{
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       background: "rgba(0,0,0,0.9)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       zIndex: 9999,
//       cursor: "pointer"
//     }}
//   >
//     {preview.type === "image" ? (
//       <img
//         src={preview.url}
//         style={{
//           maxWidth: "90%",
//           maxHeight: "90%",
//           borderRadius: "10px"
//         }}
//       />
//     ) : (
//       <video
//         src={preview.url}
//         controls
//         autoPlay
//         style={{
//           maxWidth: "90%",
//           maxHeight: "90%",
//           borderRadius: "10px"
//         }}
//       />
//     )}
//   </div>
// )}
//     </>
//   );
// };

// export default BlogsPage;

import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://server.havbit.in";

// ─── Detail Modal ───────────────────────────────────────────────────────────
const BlogDetailModal = ({ blog, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handleKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKey);
    };
  }, [onClose]);

  const formattedDate = blog.createdAt
    ? new Date(blog.createdAt).toLocaleDateString("en-IN", {
        day: "numeric", month: "long", year: "numeric"
      })
    : null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.75)", backdropFilter: "blur(6px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "16px", overflowY: "auto"
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff", borderRadius: "20px",
          width: "100%", maxWidth: "720px",
          maxHeight: "90vh", overflowY: "auto",
          boxShadow: "0 24px 60px rgba(0,0,0,0.3)",
          position: "relative", animation: "modalIn .25s ease"
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: "14px", right: "14px",
            width: "36px", height: "36px", borderRadius: "50%",
            border: "none", background: "rgba(0,0,0,0.08)",
            cursor: "pointer", display: "flex", alignItems: "center",
            justifyContent: "center", zIndex: 10, fontSize: "18px",
            color: "#374151", transition: "background .15s"
          }}
          onMouseEnter={e => e.currentTarget.style.background = "rgba(0,0,0,0.15)"}
          onMouseLeave={e => e.currentTarget.style.background = "rgba(0,0,0,0.08)"}
        >
          ✕
        </button>

        {/* Media */}
        <div style={{ width: "100%", height: "340px", background: "#f3f4f6", borderRadius: "20px 20px 0 0", overflow: "hidden" }}>
          {blog.mediaType === "video" ? (
            <video
              src={blog.media}
              controls
              autoPlay
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : blog.media ? (
            <img
              src={blog.media}
              alt={blog.title}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <div style={{
              width: "100%", height: "100%", display: "flex",
              alignItems: "center", justifyContent: "center",
              color: "#9ca3af", flexDirection: "column", gap: "8px"
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
              <span style={{ fontSize: "13px" }}>No media</span>
            </div>
          )}
        </div>

        {/* Content */}
        <div style={{ padding: "28px 32px 36px" }}>
          {/* Tags row */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px", flexWrap: "wrap" }}>
            <span style={{
              fontSize: "11px", fontWeight: 700, letterSpacing: ".06em",
              textTransform: "uppercase", padding: "3px 10px", borderRadius: "6px",
              background: blog.mediaType === "video" ? "#fdf4ff" : "#eff6ff",
              color: blog.mediaType === "video" ? "#9333ea" : "#2563eb"
            }}>
              {blog.mediaType === "video" ? "🎬 Video" : "🖼 Image"}
            </span>
            {blog.category && (
              <span style={{
                fontSize: "11px", fontWeight: 600, letterSpacing: ".05em",
                padding: "3px 10px", borderRadius: "6px",
                background: "#f0fdf4", color: "#16a34a", textTransform: "uppercase"
              }}>
                {blog.category}
              </span>
            )}
            {formattedDate && (
              <span style={{ fontSize: "12px", color: "#9ca3af", marginLeft: "auto" }}>
                📅 {formattedDate}
              </span>
            )}
          </div>

          {/* Title */}
          <h2 style={{
            fontSize: "22px", fontWeight: 800, color: "#111827",
            lineHeight: 1.35, marginBottom: "16px", letterSpacing: "-.3px"
          }}>
            {blog.title}
          </h2>

          {/* Author */}
          {blog.author && (
            <div style={{
              display: "flex", alignItems: "center", gap: "10px",
              marginBottom: "20px", paddingBottom: "20px",
              borderBottom: "1px solid #f3f4f6"
            }}>
              <div style={{
                width: "36px", height: "36px", borderRadius: "50%",
                background: "linear-gradient(135deg, #ef4444, #f97316)",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontSize: "14px", fontWeight: 700, flexShrink: 0
              }}>
                {blog.author[0]?.toUpperCase()}
              </div>
              <div>
                <p style={{ fontSize: "13px", fontWeight: 700, color: "#374151", margin: 0 }}>{blog.author}</p>
                <p style={{ fontSize: "11px", color: "#9ca3af", margin: 0 }}>Author</p>
              </div>
            </div>
          )}

          {/* Description */}
          {blog.description && (
            <p style={{
              fontSize: "15px", color: "#4b5563", lineHeight: 1.75,
              marginBottom: "20px", whiteSpace: "pre-wrap"
            }}>
              {blog.description}
            </p>
          )}

          {/* Content / Body */}
          {blog.content && (
            <div style={{
              fontSize: "15px", color: "#374151", lineHeight: 1.8,
              padding: "20px", background: "#f9fafb", borderRadius: "12px",
              borderLeft: "3px solid #ef4444"
            }}>
              <p style={{ margin: 0, whiteSpace: "pre-wrap" }}>{blog.content}</p>
            </div>
          )}

          {/* Tags */}
          {blog.tags?.length > 0 && (
            <div style={{ marginTop: "20px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
              {blog.tags.map((tag, i) => (
                <span key={i} style={{
                  fontSize: "12px", padding: "4px 12px", borderRadius: "20px",
                  background: "#f3f4f6", color: "#6b7280", fontWeight: 500
                }}>
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// ─── Card ───────────────────────────────────────────────────────────────────
const BlogCard = ({ blog, onClick }) => {
  const [imgError, setImgError] = useState(false);
  const [hovered, setHovered] = useState(false);

  const formattedDate = blog.createdAt
    ? new Date(blog.createdAt).toLocaleDateString("en-IN", {
        day: "numeric", month: "short", year: "numeric"
      })
    : null;

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "#fff", borderRadius: "16px",
        border: "1px solid #e5e7eb", overflow: "hidden",
        cursor: "pointer",
        boxShadow: hovered
          ? "0 8px 30px rgba(0,0,0,0.12)"
          : "0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.05)",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "box-shadow .22s, transform .22s"
      }}
    >
      {/* Thumbnail */}
      <div style={{ width: "100%", height: "200px", background: "#f3f4f6", overflow: "hidden", position: "relative" }}>
        {blog.mediaType === "video" ? (
          <>
            <video
              src={blog.media}
              preload="metadata"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
            {/* Play overlay */}
            <div style={{
              position: "absolute", inset: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "rgba(0,0,0,0.25)"
            }}>
              <div style={{
                width: "44px", height: "44px", borderRadius: "50%",
                background: "rgba(255,255,255,0.9)",
                display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#111827"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              </div>
            </div>
          </>
        ) : blog.media && !imgError ? (
          <img
            src={blog.media}
            alt={blog.title}
            style={{
              width: "100%", height: "100%", objectFit: "cover", display: "block",
              transform: hovered ? "scale(1.04)" : "scale(1)",
              transition: "transform .35s ease"
            }}
            onError={() => setImgError(true)}
          />
        ) : (
          <div style={{
            width: "100%", height: "100%",
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            gap: "8px", color: "#9ca3af"
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            <span style={{ fontSize: "12px" }}>No image</span>
          </div>
        )}

        {/* Media type badge */}
        <div style={{
          position: "absolute", top: "10px", left: "10px",
          fontSize: "10px", fontWeight: 700, letterSpacing: ".06em",
          textTransform: "uppercase", padding: "3px 8px", borderRadius: "5px",
          background: blog.mediaType === "video" ? "rgba(147,51,234,0.9)" : "rgba(37,99,235,0.9)",
          color: "#fff", backdropFilter: "blur(4px)"
        }}>
          {blog.mediaType === "video" ? "🎬 Video" : "🖼 Image"}
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: "16px 18px 20px" }}>
        {formattedDate && (
          <p style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "6px", fontWeight: 500 }}>
            {formattedDate}
          </p>
        )}
        <h3 style={{
          fontSize: "15px", fontWeight: 700, color: "#111827",
          lineHeight: 1.45, marginBottom: "8px",
          display: "-webkit-box", WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical", overflow: "hidden"
        }}>
          {blog.title}
        </h3>
        <p style={{
          fontSize: "13px", color: "#6b7280", lineHeight: 1.6,
          display: "-webkit-box", WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical", overflow: "hidden",
          marginBottom: "14px"
        }}>
          {blog.description}
        </p>

        {/* Read more */}
        <div style={{
          display: "flex", alignItems: "center", gap: "4px",
          fontSize: "12px", fontWeight: 700, color: "#ef4444"
        }}>
          Read more
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </div>
      </div>
    </div>
  );
};

// ─── Main Page ───────────────────────────────────────────────────────────────
const BlogsPage = () => {
  const [blogs, setBlogs]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null); // blog detail modal

  useEffect(() => {
    axios.get(`${BASE_URL}/api/blogs/public/all`)
      .then(res => setBlogs(res.data.blogs || res.data || []))
      .catch(err => console.log("Error:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Plus Jakarta Sans', sans-serif; }
        @keyframes modalIn {
          from { opacity: 0; transform: translateY(24px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #f1f1f1; }
        ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 10px; }
      `}</style>

      <div style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        background: "#f8f9fc", minHeight: "100vh",
        padding: "48px 24px 80px", color: "#111827"
      }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "44px" }}>
          <div style={{
            display: "inline-block", fontSize: "12px", fontWeight: 700,
            letterSpacing: ".1em", textTransform: "uppercase",
            color: "#ef4444", background: "#fff1f2",
            padding: "4px 14px", borderRadius: "20px", marginBottom: "14px"
          }}>
            
          </div>
          <h1 style={{
            fontSize: "clamp(26px, 5vw, 40px)", fontWeight: 800,
            letterSpacing: "-.5px", marginBottom: "10px", color: "#111827"
          }}>
            Stories & Insights
          </h1>
          
        </div>

        {/* Loading */}
        {loading && (
          <div style={{
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            minHeight: "300px", gap: "16px", color: "#9ca3af"
          }}>
            <div style={{
              width: "36px", height: "36px",
              border: "3px solid #e5e7eb", borderTopColor: "#ef4444",
              borderRadius: "50%", animation: "spin .65s linear infinite"
            }} />
            <span style={{ fontSize: "14px" }}>Loading blogs...</span>
          </div>
        )}

        {/* Empty */}
        {!loading && blogs.length === 0 && (
          <div style={{
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            minHeight: "300px", gap: "12px", color: "#9ca3af"
          }}>
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/></svg>
            <p style={{ fontSize: "15px", fontWeight: 600 }}>No blogs yet</p>
          </div>
        )}

        {/* Grid */}
        {!loading && blogs.length > 0 && (
          <>
            <p style={{
              textAlign: "center", fontSize: "13px", color: "#9ca3af",
              marginBottom: "28px"
            }}>
              {blogs.length} article{blogs.length !== 1 ? "s" : ""} — click any to read
            </p>
            <div style={{
              maxWidth: "1100px", margin: "0 auto",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "22px"
            }}>
              {blogs.map(blog => (
                <BlogCard
                  key={blog._id}
                  blog={blog}
                  onClick={() => setSelected(blog)}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* Detail Modal */}
      {selected && (
        <BlogDetailModal
          blog={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </>
  );
};

export default BlogsPage;